
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/ai-code-101-for-kids",
      function () {
        return require("private-next-pages/courses/ai-code-101-for-kids.tsx");
      }
    ]);
  